import type { UnitId } from "./content/buildings.js";

export const UNIT_IDS = ["guard-robot", "raider-robot", "siege-gun"] as const;
export type TroopComposition = Readonly<Record<UnitId, string>>;
export type StandingOrder = "hold" | "assault" | "raid";

export interface BorderPosition {
  readonly troops: TroopComposition;
  readonly standingOrder: StandingOrder;
}

export interface TransitOrder {
  readonly id: string;
  readonly units: TroopComposition;
  readonly destination: "home" | string;
  readonly finalDestination: string | null;
  readonly completesAtMs: number;
  readonly returnAfterArrival: boolean;
}

export interface AutoReinforceOrder {
  readonly id: string;
  readonly destination: string;
  readonly desired: Readonly<Record<UnitId, string | null>>;
}

export interface LogisticsState {
  readonly reinforcement?: ReinforcementState;
  readonly nextTransitId: number;
  readonly nextAutoOrderId: number;
  readonly nextAutoReinforceAtMs: number;
  readonly borders: Readonly<Record<string, BorderPosition>>;
  readonly transits: readonly TransitOrder[];
  readonly autoReinforce: readonly AutoReinforceOrder[];
}

export interface ReinforcementState {
  readonly timers?: Readonly<
    Record<string, { readonly seconds: number; readonly nextAtMs: number }>
  >;
  readonly shares: Readonly<Record<UnitId, Readonly<Record<string, number>>>>;
  readonly modes: Readonly<Record<string, "continuous" | "gather">>;
  readonly gathered: Readonly<Record<string, TroopComposition>>;
  readonly cursors: Readonly<Record<UnitId, number>>;
}

export interface BorderSupply {
  readonly required: string;
  readonly received: string;
  readonly effectiveness: string;
}
